"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styled = _interopRequireDefault(require("../styled"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalBackdrop = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  display: flex;\n\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.theme.modalBackdrop;
});

var ModalBackdropClickZone = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n"])));

var ModalWrapper = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: grid;\n  z-index: 2;\n  border-radius: 5px;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto 1fr auto;\n  grid-template-areas:\n    'title close'\n    'body body'\n    'actions actions';\n  user-select: contain;\n"])));

var Close = (0, _styled["default"])(_IconButton["default"])(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 20px;\n  height: 20px;\n  padding: 6px;\n  box-sizing: content-box;\n  color: ", ";\n  grid-area: close;\n"])), function (props) {
  return props.theme.modalCloseIconColor;
}); // TODO convert to FC

/**
 * A convenient way to grab the user's attention for something, or to prompt them to perform an action.
 *
 * For a modal to be visible, it needs to be mounted *and* have the `open` prop set to `true`. Unmounting, or setting the prop
 * to something falsey, will cause the modal to close.
 *
 * There should only ever be *one* modal open at a time. While it's possible to have modals overlap, it doesn't make sense
 * from an UI perspective.
 *
 * Be careful not to get the user stuck with a modal; always provide a way to close the modal!
 *
 * In terms of styling, the modal doesn't offer any styling for itself. You can either assign it CSS calsses, or use
 * styled-components (`const StyledModal = styled(Modal)...`) to apply consistent styling to the modal.
 * Modals might serve different purposes, which could mean struggling against the default styles in some situations.
 *
 * Keep in mind that some components within the modal (`Checkbox`, `Radio`, etc) still react to themeing, even though the
 * modal itself doesn't neccessarily have the theme's background/foreground.
 *
 * Use `grid-area` css property to position the content, `title` for the title area and `body` for the body area. If you dont
 * use these it will likely not look as you expect. There is also a `grid-area` of `actions` for the actions but this is just
 * for back compatibility and will likely be removed at some point.
 */

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    _classCallCheck(this, Modal);

    return _super.apply(this, arguments);
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          modalRootSelector = _this$props.modalRootSelector,
          open = _this$props.open,
          children = _this$props.children,
          closeWith = _this$props.closeWith,
          backdropClick = _this$props.backdropClick,
          rest = _objectWithoutProperties(_this$props, ["modalRootSelector", "open", "children", "closeWith", "backdropClick"]);

      var closeButton = null;

      if (!open) {
        return null;
      }

      var rootNode = document.querySelector(modalRootSelector);

      if (closeWith) {
        closeButton = /*#__PURE__*/React.createElement(Close, {
          onClick: closeWith
        }, /*#__PURE__*/React.createElement("svg", {
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
        })));
      }

      if (!rootNode) {
        throw new Error("Missing root node for modals. Modal expected to find the root node using ".concat(modalRootSelector, ")."));
      }

      return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/React.createElement(ModalBackdrop, null, /*#__PURE__*/React.createElement(ModalBackdropClickZone, {
        onClick: backdropClick
      }), /*#__PURE__*/React.createElement(ModalWrapper, rest, closeButton, children)), rootNode);
    }
  }]);

  return Modal;
}(React.Component);

_defineProperty(Modal, "defaultProps", {
  modalRootSelector: '#modal-root'
});

var _default = Modal;
exports["default"] = _default;